import { GlobalSettingEnum } from 'api/model';
import useMe from 'contexts/authentication/useMe';
import { useMemo } from 'react';
import useGlobalSettings from './useGlobalSettings';

/**
 * Ser användaren fliken Inställningar → Ruttplanering (adresser utan position, hemankare,
 * ruttprov och ruttplaneringens inställningar)?
 *
 * Egen lista (GlobalSettingEnum 116) som SuperAdmin styr under Globala inställningar. Underflikarna
 * behåller sina rollkrav ovanpå listan, så listan kan bara smalna av.
 *
 * Den här hooken styr bara vad som SYNS. Spärren för positionerna sitter i
 * RoutePlanningSettingsController, som prövar samma lista.
 */
const useHasAccessToRoutePlanningSettings = () => {
  const me = useMe();
  const { parsedData: globalSettings, loaded } = useGlobalSettings();

  return useMemo(() => {
    if (!me || !loaded) {
      return false;
    }

    // Tom lista = dolt för alla, också för SuperAdmin. Fliken ska slås på uttryckligen.
    return (
      globalSettings[GlobalSettingEnum.UsersWithAccessToRoutePlanningSettings][
        me.userID
      ] === true
    );
  }, [me, loaded, globalSettings]);
};

export default useHasAccessToRoutePlanningSettings;
